<template>
  <div class="v-table-wrapper-body" :style="{height: bodyHeight}" @scroll="scrollHandler">
    <div
      :style="{width: commonWidth}"
      class="v-table-wrapper-body-common">
      <v-data-table
        ref="tableCommon"
        class="v-table-wrapper-body-common-table"
        hide-default-footer
        hide-default-header
        :items="items"
        :items-per-page="items.length || 20"
        :headers="headers"
      >

        <template v-slot:header="scope">
          <v-colgroup
            state="body common"
            :scope="scope"
          />

        </template>
        <template v-slot:body="scope">
          <body-slot :scope="scope" :type="'common'">

            <template
              v-for="(_, slotKey) of $scopedSlots"
              v-slot:[slotKey]="scope"
            >
              <slot :name="slotKey" v-bind="scope"></slot>
            </template>

          </body-slot>
        </template>

      </v-data-table>
    </div>
    <div
      v-if="isFixed"
      :style="{width: fixedWidth, left: scrollLeft, height: bodyCommonTableHeight}"
      class="v-table-wrapper-body-fixed">
      <v-data-table
        class="v-table-wrapper-body-fixed-table"
        hide-default-footer
        hide-default-header
        :items="items"
        :items-per-page="items.length || 20"
        :headers="fixedHeaders"
      >

        <template v-slot:header="scope">
          <v-colgroup
            state="body fixed"
            :scope="scope"/>
        </template>

        <template v-slot:body="scope">
          <body-slot :scope="scope" :type="'fixed'">

            <template
              v-for="(_, slotKey) of $scopedSlots"
              v-slot:[slotKey]="scope"
            >
              <slot :name="slotKey" v-bind="scope"></slot>
            </template>

          </body-slot>
        </template>

      </v-data-table>
    </div>
  </div>
</template>

<script>
  import BodySlot from './BodySlot'
  import VColgroup from './VColgroup'
  import { store } from '../store/'

  export default {
    name: 'TableWrapperBody',
    components: {VColgroup, BodySlot},
    props: {
      isFixed: {
        type: Boolean,
        default: false
      },
      items: Array,
      headers: Array,
      fixedHeaders: Array
    },
    data: () => ({
      bodyHeight: '100%',
      bodyCommonTableHeight: '100%'
    }),
    computed: {
      commonWidth() {
        if (store.state.commonWidth) return store.state.commonWidth + 'px'
      },
      fixedWidth() {
        if (store.state.fixedWidth) return store.state.fixedWidth + 'px'
      },
      scrollLeft() {
        return store.state.scrollLeft + 'px'
      },
      mainHeightChanged() {
        return store.state.mainHeight
      },
    },
    methods: {
      scrollHandler(e) {
        this.saveScrollWidth(e.target)
        store.commit('setScrollTop', e.target.scrollTop)
        store.commit('setScrollLeft', e.target.scrollLeft)
      },
      changeBodyHeight() {
        this.$nextTick(() => {
          let height = store.state.mainHeight - store.state.headerHeight
          return height < this.$refs.tableCommon.$el.offsetHeight ? this.bodyHeight = height + 'px' : this.bodyHeight = '100%'
        })
      },
      changeHeight() {
        let height = this.$refs.tableCommon.$el.offsetHeight
        this.bodyCommonTableHeight = height + 'px'
      },
      saveScrollWidth(element) {
        const scrollWidth =  element.offsetWidth - element.clientWidth;
        store.commit('setScrollWidth', scrollWidth)
      }
    },
    watch: {
      items: {
        handler() {
          this.$nextTick(() => {
            this.changeBodyHeight()
            this.changeHeight()
          })
        }
      },
      mainHeightChanged: {
        handler() {
          this.changeBodyHeight()
          this.changeHeight()
        }
      },
    },
    mounted() {
      this.changeBodyHeight()
      this.changeHeight()
    }
  }
</script>

<style lang="scss" scoped>
  .v-table-wrapper-body {
    position: relative;
    overflow-y: auto;
    overflow-x: visible;
    z-index: 1;

    &-common {
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;
    }

    &-fixed {
      overflow: hidden;
      position: absolute;
      top: 0;
      height: 100%;
      z-index: 2;
      box-shadow: 10px 0px 10px -12px black;
    }
  }
</style>
